import { Types } from '../types'

// Default configs
export const config: Types.AppConfigInput = {
  general: {
    timingBase: 400,
    useRouter: false,
    turnOffTransitions: false, 
    transitionFunction: 'ease-in-out',
    siteContainerWidth: null, 
    mobileBreakpoint: 1024,
    sizingBase: 16,
  },
  desktopMenu: {
    isAlwaysOpened: false,
    itemTextSize: 1.25,
    itemSpacing: 0.5,
    navBarHeight: 6.5
  },
  mobileMenu: {
    menuTitle: 'Categories',
    treatAsLink: false,
    inverse: false, 
    showTrigger: false,
    maxWidth: 320
  },
}

export const theme: any = {
  dark: {
    general: {
      cssFont: 'inherit',
      overlayBackground: 'rgba(0, 0, 0, 0.5)', 
      scrollBarSize: 1, 
      scrollBarColor: '#FFFFFF'
    },
    desktopMenu: {
      itemTextColor: '#ffffff',
      itemActiveTextColor: '#ffffff',
      itemUnderlineColor: '#ffffff',
      megamenuBackgroundColor: '#2d2d2d',
      submenuItemTextColor: '#fff'
    },
    mobileMenu: {
      itemBackground: '#FFFFFF',
      itemHoverBackground: 'transparent',
      hoverTransition: true,
      textColor: 'inherit',
      textSize: 'inherit',
      textBold: 'inherit',
      categoryBackground: '#FFFFFF',
      categoryTextColor: 'inherit',
      categoryTextSize: 'inherit',
      categoryTextBold: 'inherit',
      dividerBackground: 'transparent',
      dividerSize: 0,
      iconSize: 2,
      hamburgerColor: '#fff'
    }
  },
  light: {
    general: {
      cssFont: 'inherit',
      overlayBackground: 'rgba(0, 0, 0, 0.5)', 
      scrollBarSize: 1, 
      scrollBarColor: '#FFFFFF'
    },
    desktopMenu: {
      itemTextColor: '#ffffff',
      itemUnderlineColor: '#ffffff',
      megamenuBackgroundColor: '#2d2d2d',
      submenuItemTextColor: '#fff'
    },
    mobileMenu: {
      itemBackground: '#FFFFFF',
      itemHoverBackground: 'transparent',
      hoverTransition: true,
      textColor: 'inherit',
      textSize: 'inherit',
      textBold: 'inherit',
      categoryBackground: '#FFFFFF',
      categoryTextColor: 'inherit',
      categoryTextSize: 'inherit',
      categoryTextBold: 'inherit',
      dividerBackground: 'transparent',
      dividerSize: 0,
      iconSize: 2,
      hamburgerColor: '#fff'
    }
  }
}